<template>
	<el-drawer :modal="false" 
		title="Edit Profile" 
		:visible.sync="drawerEditProfile"
		class="drawer-edit-profile"
		size="45%"
	>
		<b-container>
			<el-collapse v-model="activeName" accordion>
				<el-collapse-item name="personal" class="my-3">
					<div slot="title" class="collapse-header">
						<h3 class="mb-0">Personal Detail</h3>
					</div>
					<PersonalDetailForm />
				</el-collapse-item>

				<el-collapse-item name="bank" class="my-3">
					<div slot="title" class="collapse-header">
						<h3 class="mb-0">Bank Detail</h3>
					</div>
					<BankDetailForm />
				</el-collapse-item>

				<el-collapse-item name="employment" class="my-3">
					<div slot="title" class="collapse-header">
						<h3 class="mb-0">Employment Detail</h3>
					</div>
					<EmploymentDetailForm />
				</el-collapse-item>

				<el-collapse-item name="spouse" class="my-3">
					<div slot="title" class="collapse-header">
						<h3 class="mb-0">Spouse/Emergency Detail</h3>
					</div>
					<SpouseDetailForm />
				</el-collapse-item>
			</el-collapse>
		</b-container>
	</el-drawer>
</template>
<script>
import { Button, Drawer, Collapse, CollapseItem } from 'element-ui'
import PersonalDetailForm from '@/views/CustomerProfile/Drawers/DrawerEditProfile/PersonalDetailForm'
import BankDetailForm from '@/views/CustomerProfile/Drawers/DrawerEditProfile/BankDetailForm'
import EmploymentDetailForm from '@/views/CustomerProfile/Drawers/DrawerEditProfile/EmploymentDetailForm'
import SpouseDetailForm from '@/views/CustomerProfile/Drawers/DrawerEditProfile/SpouseDetailForm'


export default {
	props: {
		active_slot: String
	},
	components: {
		PersonalDetailForm,
		BankDetailForm,
		EmploymentDetailForm,
		SpouseDetailForm,
		[Button.name]: Button,
		[Drawer.name]: Drawer,
		[Collapse.name]: Collapse,
		[CollapseItem.name]: CollapseItem,
	},
	mixins: [
		// helperFunctionMixin
	],
	data() {
		return {
			drawerEditProfile: false,
			activeName: '',
			tables: [],
		};
	},
	watch: {
		'active_slot': {
			handler(newValue, oldValue) {
				this.activeName = newValue
			},
			immediate: true
		}
	},
	methods: {
		viewEditProfile() {
			this.drawerEditProfile = !this.drawerEditProfile;
		}
	}
}
</script>
